// services/propertieService.js
import axiosInstance from "./axiosInstance";
import { API_URL } from "../config/api"; 

// Lấy tất cả xe (có lọc, phân trang)
export const getAllProperties = async (filters = {}, page = 1, limit = 12) => {
    const queryParams = new URLSearchParams({ ...filters, page, limit });
    const res = await axiosInstance.get(`/properties?${queryParams.toString()}`);
    return res.data;
};

// Lấy chi tiết xe theo ID
export const getPropertiesById = async (id) => {
    const res = await axiosInstance.get(`/properties/${id}`);
    return res.data;
};

// Lấy xe tương tự theo brand
export const getSimilarProperties = async (brand) => {
    const res = await axiosInstance.get(`/properties?brand=${encodeURIComponent(brand)}`);
    const data = res.data;
    return Array.isArray(data.properties) ? data.properties : [];
};


// Lấy xe tương tự theo giá
export const getSimilarPropertiesByPrice = async (price, range = 200) => {
    // range: khoảng cách giá +- (VD: 200 triệu)
    const minPrice = price - range;
    const maxPrice = price + range;

    const res = await axiosInstance.get(
        `/properties?minPrice=${minPrice}&maxPrice=${maxPrice}`
    );
    const data = res.data;
    return Array.isArray(data.properties) ? data.properties : [];
};


// Upload ảnh xe
export const uploadPropertyImages = async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file) => formData.append("images", file));

    const res = await fetch(`${API_URL}/api/upload`, {
        method: "POST",
        body: formData,
        cache: "no-store",  // FIX lỗi HTTP/2
        credentials: "include", // nếu backend dùng cookie
    });

    if (!res.ok) {
        throw new Error("Upload failed");
    }

    return await res.json();
};

// Tạo mới
export const createProperty = async (carData) => {
    const res = await axiosInstance.post("/properties", carData);
    return res.data;
};

// Cập nhật xe
export const updateProperty = async (id, data) => {
    const res = await axiosInstance.put(`/properties/${id}`, data);
    return res.data;
};

// Lấy xe theo user ID
// services/propertiesService.js
export const getPropertiesByUserId = async (userId, filters = {}, page = 1, limit = 6) => {
    const params = {
        ...filters,
        page,
        limit,
    };

    if (params.isSold === "all") {
        delete params.isSold;
    }

    const res = await axiosInstance.get(`/properties/by-user/${userId}`, { params });
    return res.data;
};

// Xoá xe theo ID
export const deleteProperties = async (id) => {
    const res = await axiosInstance.delete(`/properties/${id}`);
    return res.data;
};

// Lấy danh sách xe đang chờ duyệt (pending) với filter và phân trang
export const getAllPendingProperties = async (filters = {}, page = 1, limit = 12) => {
    const queryParams = new URLSearchParams({ ...filters, page, limit });
    const res = await axiosInstance.get(`/properties/pending?${queryParams.toString()}`);
    return res.data;
};

// Cập nhật trạng thái xe (approve hoặc reject) - admin
export const updatePropertiesStatus = async (id, status) => {
    const res = await axiosInstance.put(`/properties/${id}/status`, { status });
    return res.data;
};

// Lấy xe gần nhất dựa vào lat/lng
export const getNearbyProperties = async (
    lat,
    lng,
    filters = {},
    page = 1,
    limit = 20
) => {
    // Gộp params: lat, lng, page, limit và filters
    const params = {
        lat,
        lng,
        page,
        limit,
        ...filters,
    };

    // Chuyển params thành query string
    const queryParams = new URLSearchParams(params).toString();

    // Gọi API GET /properties/nearby?...
    const res = await axiosInstance.get(`/properties/nearby?${queryParams}`);

    return res.data; // { properties, total, totalPages, currentPage }
};

// Lấy QR code của xe
export const getPropertyQRCode = async (propertyId) => {
    const res = await axiosInstance.get(`/qrcode/${propertyId}`);
    return res.data;
};

